/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Filter_All_Kinds1Inputs */

const vi_cmspage_filter_all_kinds1 = /** @type {(inputs: Cmspage_Filter_All_Kinds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi loại`)
};

/**

* @param {Cmspage_Filter_All_Kinds1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_filter_all_kinds1 = /** @type {((inputs?: Cmspage_Filter_All_Kinds1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Filter_All_Kinds1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_filter_all_kinds1(inputs)
});
export { cmspage_filter_all_kinds1 as "cmsPage_filter_all_kinds" }